export default function EaganFinalCTA() {
  return (
    <>
      <section className="relative bg-[#1A365D] py-20 md:py-28 overflow-hidden">
        <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Ready to Get Started?</p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            If you need your <span className="text-[#F6C344]">travel documents</span> within hours or a few weeks, don&apos;t wait <span className="text-[#F6C344]">another minute.</span>
          </h2>
          <p className="text-white/70 text-lg mb-8 leading-relaxed">
            Start your secure order online. We handle the rest — document review, reserved agency submission, and predictable processing. No agency lines. No driving to downtown Minneapolis. No guessing.
          </p>

          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-lg px-10 py-5 rounded-md transition-all hover:scale-105 whitespace-nowrap mb-6"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-10">
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 text-white/80 hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
            </a>
            <span className="text-white/30 hidden sm:inline">|</span>
            <a
              href="mailto:contactus@fastpassportcenter.com"
              className="inline-flex items-center gap-2 text-white/80 hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line text-[#F6C344]"></i> contactus@fastpassportcenter.com
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
              { icon: "ri-award-line", text: "A+ BBB Rating" },
              { icon: "ri-lock-line", text: "Secure Checkout" },
              { icon: "ri-customer-service-2-line", text: "Real Human Support" },
              { icon: "ri-price-tag-3-line", text: "Best Price Guarantee" },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/50 text-xs">
                <i className={`${badge.icon} text-[#F6C344]`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-[#0F2240] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <a href="https://fastpassportcenter.com">
                <img
                  src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Footer.svg"
                  alt="Fast Passport Center"
                  className="h-8 w-auto mb-4"
                />
              </a>
              <p className="text-white/50 text-sm leading-relaxed mb-4 max-w-sm">
                Fast Passport Center is an approved and registered U.S. Department of State passport courier providing expedited passport services nationwide, including Eagan, MN.
              </p>
              <div className="flex items-center gap-3">
                <a href="https://www.facebook.com/fastpassportcenter/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#F6C344] hover:text-[#1A365D] text-white transition-all">
                  <i className="ri-facebook-fill text-sm"></i>
                </a>
                <a href="https://x.com/fpcnews" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#F6C344] hover:text-[#1A365D] text-white transition-all">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="https://www.instagram.com/fastpassportcenter/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#F6C344] hover:text-[#1A365D] text-white transition-all">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-sm uppercase tracking-wide text-[#F6C344] mb-4">Services</h4>
              <ul className="space-y-2">
                {[
                  ["Passport Renewal", "passport-renewal"],
                  ["New Passport", "new-passport"],
                  ["Lost/Stolen Passport", "lost-stolen-passport"],
                  ["Child Passport", "child-passport"],
                  ["Second Passport", "second-passport"],
                  ["Name Change", "name-change"],
                  ["Damaged Passport", "damaged-passport"],
                  ["Passport Card", "passport-card"],
                ].map(([label, slug]) => (
                  <li key={slug}>
                    <a
                      href={`https://fastpassportcenter.com/checkout/?passport=${slug}`}
                      className="text-white/50 hover:text-[#F6C344] text-sm transition-colors whitespace-nowrap"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-sm uppercase tracking-wide text-[#F6C344] mb-4">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a href="tel:8772530084" className="flex items-start gap-2 text-white/50 hover:text-[#F6C344] text-sm transition-colors">
                    <i className="ri-phone-line mt-0.5 flex-shrink-0"></i>
                    <span>877-253-0084</span>
                  </a>
                </li>
                <li>
                  <a href="mailto:contactus@fastpassportcenter.com" className="flex items-start gap-2 text-white/50 hover:text-[#F6C344] text-sm transition-colors">
                    <i className="ri-mail-line mt-0.5 flex-shrink-0"></i>
                    <span>contactus@fastpassportcenter.com</span>
                  </a>
                </li>
                <li className="flex items-start gap-2 text-white/50 text-sm">
                  <i className="ri-time-line mt-0.5 flex-shrink-0"></i>
                  <span>Mon–Fri, 8AM–6PM EST</span>
                </li>
                <li className="flex items-start gap-2 text-white/50 text-sm">
                  <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                  <span>1629 K Street, Suite 300<br />Washington, DC 20006</span>
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/01/bbb.png"
                  alt="BBB A+ Rating"
                  className="h-12 w-auto opacity-70"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/30 text-xs">
              &copy; 2026 Fast Passport Center. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://fastpassportcenter.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="https://fastpassportcenter.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Terms &amp; Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}